import { OrganizationType } from '../models/Organization';

export type TutorSchoolAffiliationLabel =
  | { kind: 'teachesAt'; name: string }
  | { kind: 'individualTutor' };

/**
 * Affiliation line under a tutor name.
 * BUSINESS (or unknown type with a space) → “Teaches at {spaceName}”.
 * Anything else known as not BUSINESS → “Individual Tutor”.
 * Unknown type with no space → “Individual Tutor” (e.g. user booking list).
 */
export function resolveTutorSchoolAffiliation(
  organizationType?: OrganizationType | string | null,
  spaceName?: string | null,
): TutorSchoolAffiliationLabel | null {
  const name = spaceName?.trim() || null;
  const isBusiness =
    organizationType != null && organizationType !== OrganizationType.INDIVIDUAL_TUTOR;
  const isKnownNonBusiness = organizationType === OrganizationType.INDIVIDUAL_TUTOR;

  if (isBusiness || (organizationType == null && name)) {
    return name ? { kind: 'teachesAt', name } : null;
  }

  if (isKnownNonBusiness || organizationType == null) {
    return { kind: 'individualTutor' };
  }

  return null;
}
